import { Card, Col, List, Row, Statistic} from 'antd';
import { userdata } from '../typing/table_typing';
import { Component } from 'react';
import { injectIntl, WrappedComponentProps } from '../../../intl-compat';
import { cardmargin, grayheader } from '../../CSSReferences';

export interface TableThingyMainProps extends WrappedComponentProps {
  data: {
    user: userdata,
  }
  onLoadRequested: () => void;
}

interface TableThinyViewInnerState { filteredInfo: any, sortedInfo: any }


/** A date from the hub as local date and time, or a dash if there is none. Pure. */
const asDate = (value: string | null | undefined): string =>
  value ? new Date(value).toLocaleString('de-DE') : '-';

const createItem = (items: any[]) => {
  let itemlist = [];
  for (const [key, value] of Object.entries(items)) {
    itemlist.push(<List.Item>{key} : {value} </List.Item>)
    }
    return itemlist;
  }



class StatusMonitorView extends Component<TableThingyMainProps, TableThinyViewInnerState>
{
  constructor(props: TableThingyMainProps) {
    super(props);
    this.state = {
      filteredInfo: null,
      sortedInfo: null,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      //setInterval(() => {
      // console.log(Date.now());
      this.props.onLoadRequested()
    }, 2000);

    // this.props.onButtonClicked();
  }

  
  render() {
    return (
      <div className="site-card-wrapper">
        <Row gutter={16}>
          <Col span={0.5}></Col>
          <Col span={23}>
            <Card title="Systemstatus" style={cardmargin} hoverable styles={{ header: grayheader }}>
              <Row gutter={16}>
                <Col span={4}>
                  <Card  variant="outlined">
                    <Statistic title="# CVE entries" value={this.props.data.user.num_CVE_entries} precision={0} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card  variant="outlined">
                    <Statistic title="# DNS entries" value={this.props.data.user.num_DNS_entries} precision={0} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card  variant="outlined">
                    <Statistic title="# NEWS entries" value={this.props.data.user.num_NEWS_entries} precision={0} />
                  </Card>
                </Col>
                {/* The benchmark edit tiles went on 08.10.2026 with the
                    Benchmark page; the CPE count took the place. */}
                <Col span={4}>
                  <Card  variant="outlined">
                    <Statistic title={this.props.intl.formatMessage({ id: "Statistic:CpeEntries", defaultMessage: "# CPE entries" })}
                               value={this.props.data.user.num_CPE_entries} precision={0} />
                  </Card>
                </Col>

                <Col span={4}>
                  <Card  variant="outlined">
                    <Statistic title="# Mails / unsend" value={this.props.data.user.mails_send} suffix={"/ " + this.props.data.user.mails_unsent} precision={0} />
                  </Card>
                </Col>

                <Col span={4}>
                  <Card  variant="outlined">
                    <Statistic title="# License entries / active" value={this.props.data.user.num_licenses_active_entries} suffix={"/ " + this.props.data.user.num_licenses_entries} precision={0} />
                  </Card>
                </Col>

                <Col span={8}>
                  <Card title="Versions in use" variant="borderless"> 
                  <List>{createItem(this.props.data.user.versions_is_use) as any}</List>
                  </Card>
                </Col>
              </Row>
              {/* EUVD and CIS benchmarks, since 01.10.2026 */}
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={4}>
                  <Card variant="outlined">
                    <Statistic title="# EUVD entries / exploited" value={this.props.data.user.num_EUVD_entries} suffix={"/ " + this.props.data.user.num_EUVD_exploited} precision={0} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card variant="outlined">
                    <Statistic title="EUVD synced until" value={asDate(this.props.data.user.euvd_synced_until)} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card variant="outlined">
                    <Statistic title="Last CVE check" value={asDate(this.props.data.user.last_CVE_check)} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card variant="outlined">
                    <Statistic title="# CIS benchmarks" value={this.props.data.user.num_CIS_benchmarks} precision={0} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card variant="outlined">
                    <Statistic title="# CIS recommendations / rules" value={this.props.data.user.num_CIS_recommendations} suffix={"/ " + this.props.data.user.num_CIS_rules} precision={0} />
                  </Card>
                </Col>
                <Col span={4}>
                  <Card variant="outlined">
                    <Statistic title="Last CIS import" value={asDate(this.props.data.user.cis_last_import)} />
                  </Card>
                </Col>


              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export const TableThingyView = injectIntl(StatusMonitorView);
